import { Box, Flex, Heading, Text, Button, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { LuFileEdit } from 'react-icons/lu';

const DiaryContinueBanner = ({ diary }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/diary/${diary.diaryId}`);
  };

  return (
    <Box
      bg="yellow.100"
      p={6}
      borderRadius="lg"
      boxShadow="md"
      _hover={{ bg: 'yellow.200', cursor: 'pointer' }}
      onClick={handleClick}
    >
      <Flex align="center" gap={4}>
        <Icon as={LuFileEdit} boxSize={8} color="yellow.800" />
        <Box flex="1">
          <Heading size="md" color="yellow.900">
            Continue Writing Today's Diary
          </Heading>
          {diary?.title && (
            <Text fontWeight="bold" color="yellow.800" isTruncated>
              {diary.title}
            </Text>
          )}
          {diary?.content && (
            <Text noOfLines={1} color="yellow.700" fontSize="sm">
              {diary.content}
            </Text>
          )}
        </Box>
        <Button colorScheme="yellow" variant="solid" onClick={handleClick}>
          Continue
        </Button>
      </Flex>
    </Box>
  );
};

export default DiaryContinueBanner;
